import { Button, Checkbox, Container, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControlLabel, Grid, LinearProgress, MenuItem, TextField, Typography } from "@material-ui/core"
import { useState } from "react";
import { useReportApprovers, useReportTeamInsert, useReportType, useReportWritersAndReviewer } from "../../../common/CommonQueries";
import { toast } from "react-toastify";
import { useFetchContext } from "../../../common/FetchContext";
import { Autocomplete } from "@material-ui/lab";

export const ReportTeam = () => {


    const { authAxios } = useFetchContext();

    const [repoertType, setRepoertType] = useState('');
    const [repoertWritter, setRepoertWritter] = useState('');
    const [repoertApprover, setRepoertApprover] = useState('');
    const [repoertReviwer, setRepoertReviwer] = useState('');
    const [showApprover, setShowApprover] = useState(false);
    const [isReviewerPM, setIsReviewerPM] = useState(false);
    const [ntpDays, setNtpDays] = useState('');
    const [openDialog, setOpenDialog] = useState(false);
    const [errors, setErrors] = useState<{
        repoertType?: string;
        repoertWritter?: string;
        repoertApprover?: string;
        repoertReviwer?: string;
        ntpDays?: string;
    }>({});


    const handleClose = () => {
        setOpenDialog(false);
        setShowApprover(false);
    };
    const handleOpenDialog = () => {

        setOpenDialog(true);
    };

    const handleConfirm = () => {
        setOpenDialog(false);
        setShowApprover(true);
    };

    const handleCheckboxChange = (event: any) => {
        const checked = event.target.checked;
        setShowApprover(checked);
        if (checked) {
            setRepoertApprover('');
            setOpenDialog(true);
        }
    };
    const {
        error: errorReportWriter,
        data: ReportWriterData = [],
        isLoading: isLoadingReportWirter,
        isError: isErrorReportWriter,
    } = useReportWritersAndReviewer();

    const {
        error: errorReportApprover,
        data: ReportApproverData = [],
        isLoading: isLoadingReportApprover,
        isError: isErrorReportApprover,
    } = useReportApprovers();
    const {
        error: errorReportType,
        data: ReportType,
        isLoading: isLoadingReportType,
        isError: isErrorReportType,
    } = useReportType();

    const { mutateAsync: mutate } = useReportTeamInsert();



    if (isLoadingReportType || isLoadingReportWirter || isLoadingReportApprover) {
        return (
            <>
                <LinearProgress />
                <Typography variant="body1" style={{ marginTop: "16px" }}>
                    Loading Report Team Data...
                </Typography>
            </>
        );
    }
    const validate = () => {
        const newErrors: typeof errors = {};

        if (!repoertType) newErrors.repoertType = "Report Type is required";
        if (!repoertWritter) newErrors.repoertWritter = "Writer is required";

        if (isReviewerPM === false && repoertReviwer === "") {
            newErrors.repoertReviwer = "Reviewer is required unless Project Manager is checked"
        }

        if (showApprover === false && repoertApprover === "") {
            newErrors.repoertApprover = "Approver is required unless Project Manager is checked";
        }


        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };


    const handleReviewerPMChange = (event: React.ChangeEvent<HTMLInputElement>) => {

        const checked = event.target.checked;
        setIsReviewerPM(checked);
        if (checked) {
            setRepoertReviwer('');
        }
    };





    // const handleReportType = (event: React.ChangeEvent<HTMLInputElement>) => {
    //     setRepoertType(event.target.value);
    // };

    // const handleReportApprover = (event: React.ChangeEvent<HTMLInputElement>) => {
    //     setRepoertApprover(event.target.value);
    // };

    // const handleReportWritter = (event: React.ChangeEvent<HTMLInputElement>) => {
    //     setRepoertWritter(event.target.value);
    // };

    // const handleReportReviwer = (event: React.ChangeEvent<HTMLInputElement>) => {
    //     setRepoertReviwer(event.target.value);
    // };

    const handleReportType = (value: any) => {
        setRepoertType(value);
    };

    const handleReportApprover = (value: any) => {
        setRepoertApprover(value);
    };

    const handleReportWritter = (value: any) => {
        setRepoertWritter(value);
    };

    const handleReportReviwer = (value: any) => {
        setRepoertReviwer(value);
    };

    const handleSubmit = async () => {
        if (!validate()) return;



        try {
            await mutate({
                authAxios,
                report_type: repoertType,
                writer: repoertWritter,
                approver: showApprover ? '' : repoertApprover,
                reviewer: isReviewerPM ? "" : repoertReviwer,
                duration: ntpDays,
                is_projmanager: showApprover,
                reviewer_pm: isReviewerPM
            });

            toast.success("New Report Team Member is Successfully Added");
            setRepoertType('');
            setRepoertWritter('');
            setRepoertApprover('');
            setRepoertReviwer('');
            setShowApprover(false);
            setIsReviewerPM(false);
            setNtpDays('');
        } catch (error) {

            const errorMessage =
                error?.response?.data?.detail ||
                "Error while adding Report Team Member.";
            toast.error(errorMessage);


        }


    };

    return (
        <div>


            <>
                <Container maxWidth="sm">
                    <Grid
                        container
                        style={{ marginTop: 25 }}
                        direction="row"
                        justifyContent="space-around"
                        alignItems="center"
                        spacing={2}
                    >
                        <Grid item xs={12}>
                            {/* <TextField
                                    id="reportType"
                                    name="reportType"
                                    label="Report Type"
                                    select
                                    value={repoertType}
                                    onChange={handleReportType}
                                    fullWidth
                                    margin="dense"
                                    data-testid="reportType"
                                    error={!!errors.repoertType}
                                    helperText={errors.repoertType}
                                >
                                    {ReportType.map((item: any) => (
                                        <MenuItem key={item.id} value={item.id}>
                                            {item.name}
                                        </MenuItem>
                                    ))}
                                </TextField> */}
                            <Autocomplete
                                options={ReportType || []}
                                getOptionLabel={(option: any) => option.name || ""}
                                value={ReportType.find((item: any) => item.id === repoertType) || null}
                                onChange={(event, newValue: any) => {
                                    handleReportType(newValue?.id || null);
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Report Type"
                                        margin="dense"
                                        fullWidth
                                        data-testid="reportType"
                                        error={!!errors.repoertType}
                                        helperText={errors.repoertType}
                                    />
                                )}
                            />
                        </Grid>


                        <Grid item xs={12}>
                            {/* <TextField
                                id="reportReviewer"
                                name="reportReviewer"
                                label="Report Reviewer"
                                select
                                disabled={isReviewerPM}
                                value={repoertReviwer}
                                onChange={handleReportReviwer}
                                fullWidth
                                margin="dense"
                                data-testid="reportReviewer"
                                error={!!errors.repoertReviwer}
                                helperText={errors.repoertReviwer}
                            >
                                {ReportWriterData.map((item: any) => (
                                    <MenuItem key={item.id} value={item.id}>
                                        {item.username}
                                    </MenuItem>
                                ))}
                            </TextField> */}
                            <Autocomplete
                                options={ReportWriterData || []}
                                disabled={isReviewerPM}
                                getOptionLabel={(option: any) => option.username || ""}
                                value={
                                    ReportWriterData.find((item: any) => item.id === repoertReviwer) || null
                                }
                                onChange={(event, newValue: any) => {
                                    handleReportReviwer(newValue?.id || null);
                                }}
                                getOptionSelected={(option: any, value: any) => option.id === value.id}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Report Reviewer"
                                        margin="dense"
                                        fullWidth
                                        data-testid="reportReviewer"
                                        error={!!errors.repoertReviwer}
                                        helperText={errors.repoertReviwer}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={isReviewerPM}
                                        onChange={handleReviewerPMChange}
                                        color="primary"
                                    />
                                }
                                label="Is Reviewer is PM"
                            />

                        </Grid>

                        <Grid item xs={12}>
                            {/* <TextField
                                id="reportWriter"
                                name="reportWriter"
                                label="Report Writer"
                                select
                                value={repoertWritter}
                                onChange={handleReportWritter}
                                fullWidth
                                margin="dense"
                                data-testid="reportWriter"
                                error={!!errors.repoertWritter}
                                helperText={errors.repoertWritter}
                            >
                                {ReportWriterData.map((item: any) => (
                                    <MenuItem key={item.id} value={item.id}>
                                        {item.username}
                                    </MenuItem>
                                ))}
                            </TextField> */}
                            <Autocomplete
                                options={ReportWriterData || []}
                                getOptionLabel={(option: any) => option.username || ""}
                                value={
                                    ReportWriterData.find((item: any) => item.id === repoertWritter) || null
                                }
                                onChange={(event, newValue: any) => {
                                    handleReportWritter(newValue?.id || null);
                                }}
                                getOptionSelected={(option: any, value: any) => option.id === value.id}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Report Writer"
                                        margin="dense"
                                        fullWidth
                                        data-testid="reportWriter"
                                        error={!!errors.repoertWritter}
                                        helperText={errors.repoertWritter}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            {/* <TextField
                                id="reportApprover"
                                name="reportApprover"
                                label="Report Approver"
                                select
                                disabled={showApprover}
                                value={repoertApprover}
                                onChange={handleReportApprover}
                                fullWidth
                                margin="dense"
                                data-testid="reportApprover"
                                error={!showApprover && !!errors.repoertApprover}
                                helperText={!showApprover ? errors.repoertApprover : ''}
                            >
                                {ReportApproverData.map((item: any) => (
                                    <MenuItem key={item.id} value={item.id}>
                                        {item.username}
                                    </MenuItem>
                                ))}
                            </TextField> */}
                            <Autocomplete
                                options={ReportApproverData || []}
                                disabled={showApprover}
                                getOptionLabel={(option: any) => option.username || ""}
                                value={
                                    ReportApproverData.find((item: any) => item.id === repoertApprover) || null
                                }
                                onChange={(event, newValue: any) => {
                                    handleReportApprover(newValue?.id || null);
                                }}
                                getOptionSelected={(option: any, value: any) => option.id === value.id}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Report Approver"
                                        margin="dense"
                                        fullWidth
                                        data-testid="reportApprover"
                                        error={!showApprover && !!errors.repoertApprover}
                                        helperText={!showApprover ? errors.repoertApprover : ""}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={showApprover}
                                        onChange={handleCheckboxChange}
                                        color="primary"
                                    />
                                }
                                label="Is Project Manager"
                            />
                        </Grid>



                        <Grid item xs={12}>
                            <TextField
                                id="ntp"
                                size="small"
                                fullWidth
                                placeholder="Duration"
                                value={ntpDays}
                                onChange={(e) => setNtpDays(e.target.value)}
                                inputProps={{
                                    maxLength: 3,
                                    min: 0,
                                    max: 999,
                                    inputMode: 'numeric',
                                    pattern: '[0-9]*',
                                }}
                                error={!!errors.ntpDays}
                                helperText={errors.ntpDays}
                            />
                        </Grid>





                        <Grid item xs={4} style={{ marginTop: 30 }}>
                            <Button
                                data-testid="submit"
                                variant="contained"
                                color="primary"
                                onClick={handleSubmit}
                            >
                                Submit
                            </Button>
                        </Grid>
                    </Grid>
                </Container>

                <Dialog open={openDialog} onClose={handleClose} maxWidth="md">
                    <DialogTitle>
                        <Typography>Assign Approver as Project Manager</Typography>
                    </DialogTitle>
                    <Divider />
                    <DialogContent>
                        <Typography>Are you sure do you want approver as project manager? </Typography>

                    </DialogContent>

                    <DialogActions>
                        <Button onClick={handleClose}>Cancel</Button>
                        <Button
                            onClick={handleConfirm}
                            color="primary"
                            variant="contained"
                        >
                            confirm

                        </Button>
                    </DialogActions>
                </Dialog>
            </>





        </div>
    )
}